export const DEFAULT_EMAIL_ERROR_MESSAGE = "Invalid Email address";
export const DEFAULT_REQUIRED_FIELD_MESSAGE = "This field is required";
